import React from 'react';
import { SanityObject } from '../../../lib/landingPage';
import { IconLabel as RawIconLabel } from '../../../components/landingPage/IconLabel';
import { IconProps, Icon } from '../Icon';
import { Wrapper } from '../Wrapper';

export type IconLabelProps = {
    text: string;
    icon: SanityObject<IconProps>;
};

export const IconLabel = Wrapper(
    ({ icon, text }: IconLabelProps): JSX.Element => {
        return <RawIconLabel icon={<Icon value={icon} />}>{text}</RawIconLabel>;
    },
    'iconLabel'
);
